import { Navigate } from "react-router-dom";
import { useUser } from "./UserContext";

const AdminRoute = ({ children }) => {
  const { user, loading } = useUser();

  if (loading) return null; // ⏳ Wait until localStorage check completes

  if (!user) return <Navigate to="/login" />;
  if (!user.isAdmin) return <Navigate to="/" />;

  return children;
};

export default AdminRoute;
